import { type MessageKey, type Translator } from '../../translations/translation-types';

export const getApiError = (t: Translator, status: number): { MESSAGE: string; TITLE: string; STATUS: number } => {
	return {
		MESSAGE: t(`pages:orderDetails:error:apiError:${status}:message` as MessageKey),
		TITLE: t(`pages:orderDetails:error:apiError:${status}:title` as MessageKey),
		STATUS: status,
	};
};

export const getPreAuthApiError = (t: Translator, status: number): { MESSAGE: string; TITLE: string; STATUS: number } => {
	return {
		MESSAGE: t(`pages:orderDetails:error:preAuthApiError:${status}:message` as MessageKey),
		TITLE: t(`pages:orderDetails:error:preAuthApiError:${status}:title` as MessageKey),
		STATUS: status,
	};
};
